import { Card } from "antd";

export default function SummaryCard({
  totalUploads = 0,
  totalSavings = 0,
  totalCreditsUsed = 0,
  memberSince = "-",
}) {
  return (
    <Card
      title="Your Summary"
      className="rounded-3xl shadow-sm"
    >
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-slate-600">Total Uploads</span>
          <b>{totalUploads}</b>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-slate-600">Average Savings</span>
          <b className="text-green-600">₹{totalSavings}</b>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-slate-600">Total Credits Used</span>
          <b>{totalCreditsUsed}</b>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-slate-600">Member Since</span>
          <b>{memberSince}</b>
        </div>
      </div>
    </Card>
  );
}